import React, { useEffect, useState } from "react";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { toastError } from "../../../utils";
import { putService } from "../../../services/axios/services";
import _ from "lodash";
import ActivitiesNotUsers from "../ActivitiesNotUsers/ActivitiesNotUsers";
import ActivitiesUsers from "../ActivitiesUsers/ActivitiesUsers";

const ActivitiesListItem = (props) => {
  const { item, bgColor, i, name, handleEditActivity, handleEditFeedback } =
    props;

  const [state, setState] = useState({ items: [] });

  const sensors = useSensors(
    useSensor(PointerSensor, {
      distance: 8,
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    setState({
      ...state,
      items: _.orderBy(item, ["order"], ["asc"]),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  const onDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const oldIndex = state.items.findIndex(
      (item) => `${item.id}` === active.id
    );
    const newIndex = state.items.findIndex(
      (item) => `${item.id}` === over.id
    );

    if (oldIndex === -1 || newIndex === -1) return;

    const items = arrayMove(state.items, oldIndex, newIndex);

    setState({
      ...state,
      items: items,
    });

    sendReorder(mountList(items));
  };

  const mountList = (activities) => {
    let list = [];
    activities.forEach((e) => list.push(e.id));
    return { orderedIds: list };
  };

  const sendReorder = (activities) => {
    putService({ endpoint: "activities/order", putData: activities })
      .then((res) => {
        //toastSuccess("Atividade reordenada com sucesso!");
      })
      .catch((e) => {
        toastError("Atividade reordenada com sucesso!");
      });
  };

  const returnPlaceholderText = (type) => {
    const types = {
      "A direcionar": "Não há nenhuma atividade a direcionar.",
      "A Revisar": "Não há nenhuma atividade a revisar.",
      Cancelados: "Quando uma atividade for cancelada, ela aparecerá aqui.",
      Concluídas: "Quando uma atividade for concluída, ela aparecerá aqui.",
      Default: `Não há nenhuma atividade para o(a) analista ${type}.`,
    };
    return types[type] || types["Default"];
  };

  if (!item.length) {
    return (
      <div className="activityListPlaceholder">
        {returnPlaceholderText(name)}
      </div>
    );
  }

  const verifyFormat = (item) =>
    !!item.attachments[0].attachmentType &&
    (item.attachments[0].attachmentType.name === "Capítulo/Episódio" ||
      item.attachments[0].attachmentType.name === "Episódio");

  const types = [
    "Cancelados",
    "Concluídas",
    "Feedback Pendentes",
    "A Revisar",
    "A direcionar",
  ];

  const isListUsers = () => types.includes(name);

  let windowWidth = document.body.clientWidth;

  return (
    <>
      {!isListUsers() && state.items.length > 1 && windowWidth > 768 ? (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={onDragEnd}
        >
          <SortableContext
            items={state.items.map((item) => `${item.id}`)}
            strategy={verticalListSortingStrategy}
          >
            <div>
              {state.items.map((activity, index) => {
                return (
                  <ActivitiesUsers
                    key={activity.id}
                    activity={activity}
                    index={index}
                    name={name}
                    verifyFormat={verifyFormat}
                    bgColor={bgColor}
                    handleEditActivity={handleEditActivity}
                  />
                );
              })}
            </div>
          </SortableContext>
        </DndContext>
      ) : (
        state.items.map((activity, index) => {
          return (
            <ActivitiesNotUsers
              key={activity.id}
              activity={activity}
              index={index}
              name={name}
              verifyFormat={verifyFormat}
              bgColor={bgColor}
              handleEditFeedback={handleEditFeedback}
              handleEditActivity={handleEditActivity}
            />
          );
        })
      )}
    </>
  );
};

export default ActivitiesListItem;
